import dayjs from "dayjs";

// Every date this module shows a human reads as dd-mm-yyyy. The stored value
// stays 'yyyy-mm-dd hh:mm' so sorting and comparison keep working - only the
// render step reformats.
export function formatDisplayDate(value?: string | null): string {
  if (!value) return "N/A";
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format("DD-MM-YYYY") : "N/A";
}

/** Same rule, with the clock time kept - used where the export has one. */
export function formatDisplayDateTime(value?: string | null): string {
  if (!value) return "N/A";
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format("DD-MM-YYYY HH:mm") : "N/A";
}

/** The stamp a locally created/edited row gets, in the stored ISO-ish shape. */
export function nowStamp(): string {
  return dayjs().format("YYYY-MM-DD HH:mm");
}
